import React from 'react';
import { CheckCircle2 } from 'lucide-react';
interface TrustBadgesProps {
  badges?: string[];
}
export function TrustBadges({
  badges
}: TrustBadgesProps) {
  const defaultBadges = ['Free One-Week Trial', 'Ages 3+', 'No Experience Needed', 'Kids, Adults & Families', 'Expert Coaches'];
  const displayBadges = badges || defaultBadges;
  return <div className="flex flex-wrap gap-3" data-id="element-426">
      {displayBadges.map((badge, idx) => <div key={idx} className="flex items-center gap-2 bg-white px-4 py-2 rounded-full shadow-sm border border-subtle-gray" data-id="element-427">
          <CheckCircle2 className="w-4 h-4 text-storm-red" data-id="element-428" />
          <span className="text-sm font-bold text-ink" data-id="element-429">{badge}</span>
        </div>)}
    </div>;
}